import { isProduction } from '~/stage';

export const getApiUrl = (path?: string) => {
  // return `https://cluster.api.followathletics.com${path ?? ''}`;

  const baseUrl = isProduction()
    ? 'https://api.followathletics.com'
    : 'http://localhost:5000';

  return `${baseUrl}${path ?? ''}`;
};
